import React from "react";
import { Card, CardContent, Typography, Grid, Box, IconButton, Container, Link } from "@mui/material";
import { LinkedIn } from "@mui/icons-material";
import jaimePaezPhoto from "../assets/images/jaime-paez.jpg";

const teamMembers = [
  {
    name: "Manuel Alberto Rojas Martinez",
    role: "Estudiante - Desarrollador",
    image: "https://media.licdn.com/dms/image/v2/D4E03AQECNTg9d-vneQ/profile-displayphoto-shrink_200_200/B4EZZWAHCtGYAY-/0/1745199591975?e=2147483647&v=beta&t=JLj5olINR_TsgTgQOLnLETe1Xz_ErAUXaXR1kwAfoQA",
    imagePosition: "center 18%",
    description: "Estudiante Investigador | Ingeniería y Tecnología Desarrollador de Software Full Stack con experiencia en .NET, ReactJS y SQL Server. Apasionado por la tecnología, el análisis de datos y la construcción de soluciones eficientes.",
    links: [
      { label: "Correo electrónico", href: "mailto:marojasm@itc.edu.co", text: "marojasm@itc.edu.co" },
    ],
    icons: {
      linkedIn: "https://www.linkedin.com/in/manuel-alberto-rojas-martinez-b0b306140/",
    }
  },
  {
    name: "Jaime Alberto Paez Contreras",
    role: "Docente Investigador Senior",
    image: jaimePaezPhoto,
    imagePosition: "center 22%",
    description:
      "Facultad de Ingeniería de Sistemas, Escuela Tecnológica Instituto Técnico Central. Magister en Educación, Especialista en Ingeniería de Sistemas con enfoque en innovación tecnológica. Líder Grupo Investigación VIRTUS.",
    links: [
      { label: "Correo electrónico", href: "mailto:jpaez@itc.edu.co", text: "jpaez@itc.edu.co" },
      { label: "ORCID", href: "https://orcid.org/0000-0002-7312-0180", text: "0000-0002-7312-0180" },
      {
        label: "Google Académico",
        href: "https://scholar.google.es/citations?hl=es&user=dhHrDtQAAAAJ",
        text: "Perfil en Google Académico",
      },
    ],
    icons: {},
  }
];

const TeamSection = () => {

  const handleRedirect = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Box sx={{ flexGrow: 1, py: { xs: 4, md: 6 }, backgroundColor: "white", width: "100%" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          sx={{ textAlign: "center", mb: { xs: 3, md: 4 }, fontWeight: 700 }}
        >
          Nuestro equipo
        </Typography>
      <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center">
        {teamMembers.map((member, index) => (
          <Grid item xs={12} sm={6} key={member.name + index}>
            <Card
              sx={{
                height: "100%",
                textAlign: "left",
                boxShadow: 2,
                borderRadius: 2,
                backgroundColor: "white",
                p: { xs: 1.5, md: 2 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 2,
                  bgcolor: "#f4f6f8",
                  borderRadius: 1.5,
                  py: { xs: 2, md: 2.5 },
                }}
              >
                <Box
                  component="img"
                  src={member.image}
                  alt={member.name}
                  sx={{
                    width: { xs: 200, sm: 220, md: 240 },
                    aspectRatio: "3 / 4",
                    objectFit: "cover",
                    objectPosition: member.imagePosition || "center 20%",
                    borderRadius: 1.5,
                    display: "block",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                  }}
                />
              </Box>
              <CardContent sx={{ px: 0.5 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ textAlign: "left" }}>
                  {member.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", textTransform: "uppercase", textAlign: "left" }}>
                  {member.role}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: "left", lineHeight: 1.6 }}>
                  {member.description}
                </Typography>
                {member.links?.map((link) => (
                  <Typography
                    key={link.label}
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.75, textAlign: "left", lineHeight: 1.5 }}
                  >
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      {link.label}:{" "}
                    </Box>
                    <Link
                      href={link.href}
                      underline="hover"
                      target={link.href.startsWith("mailto:") ? undefined : "_blank"}
                      rel={link.href.startsWith("mailto:") ? undefined : "noopener noreferrer"}
                      sx={{ color: "primary.main", fontWeight: 500 }}
                    >
                      {link.text}
                    </Link>
                  </Typography>
                ))}
                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
                  {member.icons.linkedIn && <IconButton onClick={() => handleRedirect(member.icons.linkedIn)}><LinkedIn /></IconButton>}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Container>
    </Box>
  );
};

export default TeamSection;